/**
 * Custom copy clipboard implementation for browser that don't support clipboard.writeText
 * @function
 * @param [text] {String} Text to be copied
 * @param [elementToFocus] {Node} Element to be focused after copy
 * @returns {Promise}
 * @example fallbackCopyTextToClipboard('Hello World', element)
 */
const fallbackCopyTextToClipboard = (text, elementToFocus) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    document.execCommand('copy');

    document.body.removeChild(textArea);
    elementToFocus?.focus();

    return Promise.resolve();
};

/**
 * Copy text to clipboard
 * @function
 * @param [text] {String} Text to be copied
 * @param [elementToFocus] {Node} Element to be focused after copy
 * @returns {Promise}
 * @example copyToClipboard('Hello World', element)
 */
export const copyToClipboard = (text, elementToFocus) => {

    if (navigator?.clipboard?.writeText) {
        return navigator.clipboard.writeText(text);
    }

    return fallbackCopyTextToClipboard(text, elementToFocus);
};

